"use strict";

const $ = require("./main.js");

$(document).ready(function ($) {
    $(document).on('change', '.js-centre-selected', function () {
        if ($(this).val() && $(this).val() != 'all') {
            location.href = '/centre/' + $(this).val();
        }
    });

    const mapsUrl = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAedo0Ue-eClfghT8QtaWghE7Qxdd_ds0U&callback=initMapCentre`;
    const mapsScript = document.createElement('script');
    mapsScript.async = true;
    mapsScript.src = mapsUrl;
    document.querySelector('head').appendChild(mapsScript);
});

function initMapCentre() {
    var spcaCentre = {
        lat: $('.js-lat').length ? parseFloat($('.js-lat').val(), 10) : -36.906669,
        lng: $('.js-lng').length ? parseFloat($('.js-lng').val(), 10) : 174.683298
    };

    var map = new google.maps.Map(document.getElementById('map'), {
        zoom: 13,
        center: spcaCentre,
        streetViewControl: false,
        mapTypeControl: false,
        scrollwheel: false,
        fullscreenControl: false,
        zoomControl: false,
        disableDefaultUI: true,
        styles: [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#41a0df"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "stylers": [
                    {
                        "color": "#dcebf6"
                    }
                ]
            },
            {
                "featureType": "poi",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#c6e2f6"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "stylers": [
                    {
                        "color": "#1483cd"
                    }
                ]
            }
        ]


    });
    var marker = new google.maps.Marker({
        position: spcaCentre,
        map: map,
        icon: {
            url: '/images/map-marker@2x.png',
            scaledSize: new google.maps.Size(23, 28)
        },
    });
    $(document).on('click', '.js-map-in', function () {
        map.setZoom(map.getZoom() + 1);
    });
    $(document).on('click', '.js-map-out', function () {
        map.setZoom(map.getZoom() - 1);
    });
};
window.initMapCentre = initMapCentre;
